module.exports = __webpack_public_path__ + "static/media/align_center_w.d28ee081.svg";